import React, {useCallback, useContext, useEffect, useState} from 'react';
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import Tooltip from "@mui/material/Tooltip";
import {OCEAN__GLOBAL_THEMA_TEXT_DARK, OCEAN__MAIN_GLOBAL_THEMA_TEXT} from "../../../strings/IT";
import IconButton from "@mui/material/IconButton";
import {setCloseSnackbar, setOpenSnackbar, setThemeType} from "../../../services/AppServices";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import {
    Avatar,
    Backdrop,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Paper,
    Step,
    StepContent,
    StepLabel,
    Stepper,
    Typography
} from "@mui/material";
import clsx from "clsx";
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import {AppContext, TicketContext} from "../../../App";
import {bigNoteRegisterRequired, valueRegister} from "../../../utils/RegisterUtils";
import CustomText from "../../widgets/inputs/CustomText";
import FileInput from "../../gestione/carico/utils/FileInput";
import CustomMultiText from "../../widgets/inputs/CustomMultiText";
import {useHistory, useParams} from "react-router-dom";
import {getTicketHistory, resetAddHistory, updateTicket} from "../../../services/TicketServices";
import { Skeleton } from '@mui/material';
import {blue, lightBlue, orange} from "@mui/material/colors";
import {useTheme} from "@mui/styles";
import moment from "moment";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import {GET_ALLEGATO_ULR} from "../../../services/utils/ApiUrls";
import {getAllegatoById} from "../../gestione/ticket/storico/StoricoTicket";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import {formatText} from "../../widgets/chat/ChatFab";
import useBackgroundImage from "../../../styles/hooks/UseNewBackground";


const UpdateTicketPage = () => {
    const contattaciClasses = ContattaciStyle();
    const classes = BaseStyle();
    const methods = useForm({
        mode: "onChange"
    });
    const [submit, setSubmit] = useState(false);
    const ticketContext = useContext(TicketContext);
    const appContext = useContext(AppContext);
    let {id, token, idSoggetto} = useParams();
    let history = useHistory();
    let theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const [file, setFile] = useState("");
    const [idAllegato, setIdAllegato] = useState("");
    const [openInformativa, setOpenInformativa] = useState(false);
    const [read, setRead] = useState(false);

    const onClick = useCallback((allegato) => {
        setIdAllegato(allegato);
        setFile("open");
    }, [])

    const handleCloseSnack = useCallback(() => {
        setCloseSnackbar(appContext.dispatch);
    }, [appContext.dispatch]);

    const onSubmit = useCallback((data) => {
        setSubmit(true)
        let stato;
        switch (ticketContext.state.ticketHistory[ticketContext.state.ticketHistory.length - 1].stato) {
            default:
                stato = "Nuovo";
                break;
            case "Aperto":
                stato = "Aperto";
                break;
            case "Preso in carico":
            case "In attesa":
            case "Risolto":
                stato = "Aperto";
                break;
        }
        updateTicket({
            ...data,
            ...ticketContext.state.ticketHistory[ticketContext.state.ticketHistory.length - 1],
            codF: data.codF?.toUpperCase(),
            rispostaUtente: true,
            active: false,
            contattoMail: true,
            stato: stato,
            ticketId: id,
            note: data.note,
        }, ticketContext.dispatch, token, false, data.codF?.toUpperCase(), idSoggetto);
    }, [ticketContext.dispatch, token, id, ticketContext.state.ticketHistory, idSoggetto])

    useEffect(() => {
        if (id && token) {
            getTicketHistory({id: id}, ticketContext.dispatch, token);
        }
    }, [id, token, ticketContext.dispatch])

    useEffect(() => {
        if (!ticketContext.state.loadingGetHistory && ticketContext.state.errorGetHistory === "") {
            switch (ticketContext.state.ticketHistory[ticketContext.state.ticketHistory.length - 1].stato) {
                default:
                    setActiveStep(0);
                    break;
                case "Nuovo":
                    setActiveStep(0);
                    break;
                case "Aperto":
                case "Preso in carico":
                    setActiveStep(1);
                    break;
                case "In attesa":
                    setActiveStep(2);
                    break;
                case "Risolto":
                    setActiveStep(3);
                    break;
            }
        } else if (!ticketContext.state.loadingGetHistory && ticketContext.state.errorGetHistory !== "") {
            history.push("/ticketScaduto");
        }
    }, [ticketContext.state.loadingGetHistory, ticketContext.state.errorGetHistory, ticketContext.state.ticketHistory, history])

    useEffect(() => {
        if (!ticketContext.state.loadingAddHistory && ticketContext.state.errorAddHistory === "") {
            setSubmit(false);
            setOpenSnackbar("success", "Ticket aggiornato con successo", appContext.dispatch);
            history.push("/contattaci");
            resetAddHistory(ticketContext.dispatch)
        } else if (!ticketContext.state.loadingAddHistory && ticketContext.state.errorAddHistory !== "") {
            setSubmit(false);
            setOpenSnackbar("error", ticketContext.state.errorAddHistory, appContext.dispatch);
        }
    }, [ticketContext.state.loadingAddHistory, ticketContext.state.errorAddHistory, history, appContext.dispatch, ticketContext.dispatch])

    useBackgroundImage();

    return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
            <div className={classes.mainNoBgCol}>
                <header className={contattaciClasses.header}>
                    <Tooltip
                        title={appContext.state.theme.palette.mode === "light" ? OCEAN__MAIN_GLOBAL_THEMA_TEXT : OCEAN__GLOBAL_THEMA_TEXT_DARK}>
                        <IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
                            {
                                appContext.state.theme.palette.mode === "light" ?
                                    <Brightness4TwoToneIcon/> :
                                    <Brightness5TwoToneIcon/>
                            }
                        </IconButton>
                    </Tooltip>
                    <Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
                        <b>La mia richiesta R{id.toString().padStart(6, '0')}</b>
                    </Typography>
                </header>
                <article className={contattaciClasses.article}>
                    <Paper
                        className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <FormProvider {...methods}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant={"h6"} align={"center"}>
                                            <b>Stato della richiesta:</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={contattaciClasses.stepperRoot}>
                                            <Stepper activeStep={activeStep} orientation={"vertical"}
                                                     style={{borderRadius: 24, backgroundColor: "rgba(255,255,255,0)"}}>
                                                <Step>
                                                    <StepLabel>
                                                        Richiesta inviata
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Typography color={"textSecondary"}>
                                                            La richiesta è stata correttamente trasmessa e sarà presa in
                                                            carico quanto prima.
                                                        </Typography>
                                                    </StepContent>

                                                </Step>
                                                <Step>
                                                    <StepLabel>
                                                        Richiesta in lavorazione
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Typography color={"textSecondary"}>
                                                            Un operatore sta attualmente gestendo la tua richiesta. Ti
                                                            invitiamo a rimanere disponibile, poiché potresti essere
                                                            contattato telefonicamente per eventuali chiarimenti o
                                                            approfondimenti.
                                                        </Typography>
                                                    </StepContent>
                                                </Step>
                                                <Step>
                                                    <StepLabel>
                                                        In attesa di documentazione o riscontro (<i>opzionale</i>)
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Typography color={"textSecondary"}>
                                                            La tua richiesta è stata presa in carico, ma sono necessarie
                                                            ulteriori informazioni per procedere. Ti invitiamo a
                                                            consultare il messaggio ricevuto e a fornire eventuali
                                                            risposte o documenti allegati richiesti.
                                                        </Typography>
                                                    </StepContent>
                                                </Step>
                                                <Step>
                                                    <StepLabel>
                                                        Richiesta gestita
                                                    </StepLabel>
                                                    <StepContent>
                                                        <Typography color={"textSecondary"}>
                                                            La tua richiesta è stata gestita e il ticket risulta
                                                            risolto. Se hai bisogno di ulteriori chiarimenti o non
                                                            ritieni la risposta soddisfacente, puoi rispondere
                                                            direttamente a questo ticket indicando i punti da
                                                            approfondire oppure aprire una nuova segnalazione.
                                                        </Typography>
                                                    </StepContent>

                                                </Step>
                                            </Stepper>
                                        </div>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant={"h6"} align={"center"}>
                                            <b>Storico della richiesta</b>
                                        </Typography>
                                        <Typography variant={"subtitle1"} color={"textSecondary"}>
                                            Consulta lo storico della tua richiesta per vedere come è stata gestita e
                                            rispondi agli operatori qualora ti venga richiesto.
                                            Visualizzerai la conversazione relativa al ticket: i messaggi degli
                                            operatori saranno mostrati a destra, mentre i tuoi a sinistra.<br/>
                                            Eventuali allegati saranno indicati da un pulsante con la dicitura
                                            "ALLEGATO"; cliccandoci potrai scaricare o visualizzare il file.
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12}>
                                        {
                                            ticketContext.state.loadingGetHistory ?
                                                <Skeleton animation={"pulse"} className={classes.roundBorder}
                                                          height={300}/> :
                                                ticketContext.state.errorGetHistory !== "" ? ticketContext.state.errorGetHistory :
                                                    <React.Fragment>
                                                        {
                                                            ticketContext.state.ticketHistory
                                                                .sort((a, b) => new Date(a.dataUltimaModifica) - new Date(b.dataUltimaModifica))
                                                                .map((item, index) => {
                                                                    if (item.lastModify === "Risposta Utente" || item.lastModify === "Online-form" || item.lastModify.includes("Richiesta utente")) {
                                                                        return (
                                                                            <Paper elevation={0} key={index}
                                                                                   id={"paper-storico" + index}
                                                                                   style={{
                                                                                       backgroundColor: item.lastModify?.includes("Richiesta utente") || item.lastModify?.includes("Risposta Utente") || item.lastModify?.includes("Online-form") ?
                                                                                           (theme.palette.mode === "light" ? orange[50] : orange[800]) :
                                                                                           (theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800]),
                                                                                       borderRadius: 24,
                                                                                       padding: 16,
                                                                                       marginRight: 100,
                                                                                       marginTop: 16
                                                                                   }}>
                                                                                <Typography variant={"subtitle2"}
                                                                                            color={"textSecondary"}>
                                                                                    {
                                                                                        item.lastModify === "Risposta Utente" ?
                                                                                            <React.Fragment>
                                                                                                Hai risposto in
                                                                                                data: {moment(item.dataCreazione).format("DD/MM/YYYY - HH:mm")}
                                                                                            </React.Fragment> :
                                                                                            item.lastModify.includes("Richiesta utente") ?
                                                                                                <React.Fragment>
                                                                                                    <b>Tramite
                                                                                                        callcenter</b> hai
                                                                                                    chiesto in
                                                                                                    data: {moment(item.dataCreazione).format("DD/MM/YYYY - HH:mm")}
                                                                                                </React.Fragment> :
                                                                                                <React.Fragment>
                                                                                                    Hai scritto in
                                                                                                    data: {moment(item.dataCreazione).format("DD/MM/YYYY - HH:mm")}
                                                                                                </React.Fragment>
                                                                                    }
                                                                                </Typography>
                                                                                <Typography variant={"subtitle1"}>
                                                                                    {item.note.includes("#RICHIESTA_CHIAMATA") && "Richiesta di chiamata da parte tua"}
                                                                                    {formatText(item.note.replaceAll(/#(\S*)/g, ""))}
                                                                                </Typography>
                                                                                {item.allegato && item.allegato.split(" ").map((allegato, index) => {
                                                                                    return (
                                                                                        <Tooltip key={index}
                                                                                                 title={"Clicca visualizzare un anteprima del file o per scaricarlo"}>
                                                                                            <Chip
                                                                                                label={"ALLEGATO: " + allegato}
                                                                                                color={"secondary"}
                                                                                                avatar={<Avatar
                                                                                                    style={{backgroundColor: orange[400]}}>{index}</Avatar>}
                                                                                                onClick={() => onClick(allegato)}
                                                                                                style={{
                                                                                                    marginRight: 8,
                                                                                                    marginTop: 8,
                                                                                                    backgroundColor: orange[200]
                                                                                                }}
                                                                                                clickable/>
                                                                                        </Tooltip>
                                                                                    )
                                                                                })}
                                                                            </Paper>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <Paper elevation={0} key={index + 1000}
                                                                                   id={"paper-storico" + index}
                                                                                   style={{
                                                                                       backgroundColor: theme.palette.mode === "light" ? blue[50] : blue[800],
                                                                                       borderRadius: 24,
                                                                                       padding: 16,
                                                                                       marginLeft: 100,
                                                                                       marginTop: 16
                                                                                   }}>
                                                                                <Typography variant={"subtitle2"}
                                                                                            color={"textSecondary"}>
                                                                                    <b>Un operatore</b> in
                                                                                    data: {moment(item.dataCreazione).format("DD/MM/YYYY - HH:mm")}
                                                                                </Typography>
                                                                                <Typography variant={"subtitle1"}>
                                                                                    {
                                                                                        item.note.includes("#MOSTRA_USER") && formatText(item.note.replaceAll(/#(\S*)/g, ""))
                                                                                    }
                                                                                </Typography>
                                                                                {item.note.includes("#MOSTRA_USER") && item.allegato && item.allegato.split(" ").map((allegato, index) => {
                                                                                    return (
                                                                                        <Tooltip key={index}
                                                                                                 title={"Clicca visualizzare un anteprima del file o per scaricarlo"}>
                                                                                            <Chip
                                                                                                label={"ALLEGATO: " + allegato}
                                                                                                color={"secondary"}
                                                                                                avatar={
                                                                                                    <Avatar>{index}</Avatar>}
                                                                                                onClick={() => onClick(allegato)}
                                                                                                style={{
                                                                                                    marginRight: 8,
                                                                                                    marginTop: 8
                                                                                                }} clickable/>
                                                                                        </Tooltip>
                                                                                    )
                                                                                })}
                                                                            </Paper>
                                                                        );
                                                                    }
                                                                })
                                                        }
                                                    </React.Fragment>
                                        }
                                    </Grid>

                                    {
                                        ticketContext.state.loadingGetHistory ?
                                            <Skeleton animation={"pulse"} className={classes.roundBorder}
                                                      height={300}/> :
                                            ticketContext.state.errorGetHistory !== "" ? ticketContext.state.errorGetHistory :
                                                checkIfBlock(ticketContext.state.ticketHistory) ?
                                                    <Grid item xs={12}>
                                                        <Typography variant={"h6"} align={"center"}>
                                                            Non possibile aggiungere ulteriori note e/o allegati alla
                                                            richiesta.
                                                        </Typography>
                                                    </Grid> :
                                                    <React.Fragment>
                                                        <Grid item xs={12}>
                                                            <Typography variant={"h6"} align={"center"}>
                                                                <b>Identificazione</b>
                                                            </Typography>
                                                            <Typography variant={"subtitle1"} color={"textSecondary"}>
                                                                Per poter aggiungere note alla tua richiesta è
                                                                necessario identificarti. Ti chiediamo di inserire lo
                                                                stesso documento identificativo (es. Codice Fiscale,
                                                                Carta d’Identità, Numero di Patente, Passaporto, Codice
                                                                STP) utilizzato in fase di apertura della richiesta.
                                                            </Typography>

                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <CustomText
                                                                control={methods.control}
                                                                rules={valueRegister}
                                                                name={"codF"}
                                                                label={"Valore identificativo"}
                                                                autoFocus={false}
                                                                inputProps={{
                                                                    className: classes.input
                                                                }}
                                                                error={methods.errors["codF"]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant={"h6"} align={"center"}>
                                                                <b>Note e allegati</b>
                                                            </Typography>
                                                            <Typography variant={"subtitle1"} color={"textSecondary"}>
                                                                Se ti è stato richiesto di fornire un riscontro, oppure
                                                                desideri aggiungere ulteriori informazioni alla tua
                                                                richiesta, puoi farlo compilando il campo note
                                                                sottostante.
                                                                Per allegare documenti, utilizza l’apposito campo: puoi
                                                                cliccarvi sopra o trascinare i file al suo interno. È
                                                                possibile caricare più documenti, uno alla volta oppure
                                                                selezionandoli contemporaneamente.
                                                            </Typography>

                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <CustomMultiText
                                                                inputRef={methods.register(bigNoteRegisterRequired)}
                                                                name={"note"}
                                                                label={"Note da aggiungere al ticket *"}
                                                                autoFocus={false}
                                                                error={methods.errors["note"]}
                                                                rows={10}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FileInput name={"allegati"} multiple={true} accept={"*"}/>
                                                        </Grid>
                                                        <Grid item xs={12}
                                                              style={{display: "flex", justifyContent: "center"}}>
                                                            <Button variant={"contained"} color={"primary"}
                                                                    disableElevation
                                                                    className={classes.roundButton}
                                                                    onClick={methods.handleSubmit(onSubmit)}
                                                                    disabled={submit}
                                                                    style={{fontSize: 18, borderRadius: 24}}>
                                                                <b>Invia modifiche</b>
                                                            </Button>
                                                        </Grid>
                                                    </React.Fragment>
                                    }
                                </Grid>
                            </FormProvider>
                        </form>
                    </Paper>
                </article>
                <footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
                    <Typography align={"center"} style={{color: "#000000", padding: 5}}>
                        Copyright © 2025 Atlantis. Tutti i diritti riservati.
                    </Typography>
                </footer>
            </div>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
                <Alert style={{borderRadius: 28}} onClose={handleCloseSnack}
                       severity={appContext.state.severity}>
                    {appContext.state.message}
                </Alert>
            </Snackbar>
            {
                file !== "" &&
                <Dialog PaperProps={{
                    className: clsx(classes.roundBorder)
                }} open={file !== ""} onClose={() => setFile("")} maxWidth={"lg"} fullWidth={true}>
                    <DialogTitle><b>Dettaglio allegato</b></DialogTitle>
                    <DialogContent style={{height: 900, overflowY: "scroll"}}>
                        <DialogContentText>
                            In questa schermata visualizzi solo le anteprime delle immagini, in caso il file sia un pdf o
                            altro non è
                            disponibile al momento un' anteprima.<br/>
                            Se <b>NON LO VISUALIZZI</b> utilizza il pulsante <b>SCARICA</b> che trovi in basso a destra.
                        </DialogContentText>
                        <img
                            style={{
                                width: "100%"
                            }}
                            src={GET_ALLEGATO_ULR + idAllegato}
                            alt={"allegato"}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button size={"small"} variant={"text"} onClick={() => setFile("")} className={classes.roundButton}
                                style={{borderRadius: 24}}
                        >
                            <b>Chiudi</b>
                        </Button>
                        <Tooltip
                            title={"Scarica l'allegato. É possibile che l'operazione non sia immediata, ti invito ad attendere qualche minuto in più"}>
                            <Button size={"small"} variant={"contained"} color={"primary"} disableElevation
                                    className={classes.roundButton} style={{borderRadius: 24}}
                                    onClick={() => getAllegatoById(idAllegato)}>
                                <b>Scarica</b>
                            </Button>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            }
            <SimpleDialog
                open={openInformativa}
                title={"Bentornato su Atlantis!"}
                content={
                    <DialogContentText component={"div"}>
                        <b>Informativa e privacy</b><br/>

                        Gentile Sig./Sig.ra,<br/>

                        nel caso in cui sia entrato/a in Italia attraverso trasporto aereo, ferroviario, marittimo e
                        stradale, anche
                        se asintomatico, dovrà comunicare immediatamente il proprio ingresso al Dipartimento di
                        Prevenzione della
                        Azienda ASL di competenza per essere sottoposto a sorveglianza sanitaria e osservare un periodo
                        di
                        isolamento, così come disposto dalla vigente normativa.<br/>
                        <br/>
                        I dati personali che conferirà con la compilazione del presente modulo on line saranno trattati
                        utilizzando
                        modalità manuali, informatiche e telematiche, nel rispetto e nei limiti stabiliti dalla
                        normativa
                        vigente.<br/>
                        <br/>
                        DICHIARAZIONE DI PRESA VISIONE DELL’INFORMATIVA PRIVACY. Dichiaro di avere letto e preso
                        conoscenza delle
                        informazioni, rese ai sensi dell’art. 13 del Regolamento UE 2016/679, relative al trattamento
                        dei miei dati
                        personali, pubblicate alla pagina web {" "}
                        <a style={{color: theme.palette.primary.main}}
                           href={"https://www.regione.piemonte.it/web/note-legali-privacy"}
                           target="_blank"
                           rel="noopener noreferrer">https://www.regione.piemonte.it/web/note-legali-privacy</a>.<br/>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color={"primary"}
                                    checked={read}
                                    onChange={() => setRead(!read)}
                                    name="read"/>
                            }
                            label={"Ho letto integralmente e compreso l'informativa sul trattamento dei dati personali"}
                        />
                    </DialogContentText>
                }
                actions={
                    <DialogActions>
                        <Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
                                color={"primary"} style={{borderRadius: 24}}
                                onClick={() => setOpenInformativa(false)} disabled={!read}>
                            <b>Confermo</b>
                        </Button>
                    </DialogActions>
                }
            />
        </React.Fragment>
    );
}

function Alert(props) {
    return <MuiAlert elevation={16} variant="filled" {...props} />;
}

function checkIfBlock(array) {
    let contain = false;
    array.forEach(item => {
        if (item.note.includes("#BLOCCA_RISPOSTE")) {
            contain = true;
        }
    })
    return contain;
}

export default React.memo(UpdateTicketPage);

// https://localhost:4126/ticket/37/wdnHehjT+Tbsif9lmavSgOyEra4b+gfIT8O9QHuAFnJkSTFci5UP8KGBqZDJRfSAAzEyAqzu2mJPaT1TiD-iVgmK8wzWmFehHZ+NaAvordhAWzvkFPXrD9rfYcB8nVvYMl3rQ8PAkt4ZiUN76HRqhSSgyXXWHlSy5C6hGbJ7TXyPs6GEfYUEdiuQnHtlBy+brZ5tuoq0G4si7aH0ntlRQZxMbqtBK0wLJUhZnRbDr2cNIFu6hsDAvzoHkrMDAXpfX84n7Zx699kEuMBPHNpa9yO6B2yTaAnQTijy2bYGOiza108dDEhV0D65I0UVG7BXXHrtPAoJD31Jhh2GnEjBGwmFCnLxye84P7ZDtqxB8Xc=
